// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b4db52b7","102":"8a3bb9ae","229":"22f32d1f","239":"0d3e80b3","453":"efd46803","459":"9c4834e8","475":"003a9112","522":"f68668c6","591":"25aaaedf","694":"a7c20dbe","893":"c62a71e4"}[chunkId] + ".chunk.js";
};